import cn from 'classnames';
import React from 'react';
import ReactModal from 'react-modal';

import domService from '../../services/domService';
import helpers from '../../utils/helpers';
import {CancelIcon} from '../Icons';
import styles from './Popup.module.scss';

const AppPopup = (props) => {
    //IA: closeTimeoutMS = 1 is needed to run popup 'close' function
    //    if Popup component is removed from DOM NOT by isOpen property
    const {
        children,
        className,
        closeTimeoutMS = 1,
        shouldReturnFocusAfterClose,
        isCloseVisible,
        onClose,
        ...restProps
    } = props;
    const isCloseFunction = typeof onClose === 'function';
    const onPopupClose = (action) => {
        if (isCloseFunction) {
            helpers.runFunction(onClose);

            if (action) {
                helpers.runFunction(action);
            }
        }
    };

    return (
        <ReactModal
            parentSelector={domService.getComponentsWrapperElement}
            shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
            className={cn(styles.AppPopup, className)}
            closeTimeoutMS={closeTimeoutMS}
            ariaHideApp={false}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            onRequestClose={onPopupClose}
            {...restProps}
        >
            {isCloseVisible && (
                <button className='absolute right-6 top-6' onClick={() => onClose(false)}>
                    <CancelIcon />
                </button>
            )}
            {children}
        </ReactModal>
    );
};

export default AppPopup;
